/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_Hint_TickInputs */

const vi_movement_breakdown_hint_tick = /** @type {(inputs: Movement_Breakdown_Hint_TickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick để xem theo từng SP. Bỏ tick về tổng.`)
};

/**

* @param {Movement_Breakdown_Hint_TickInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_hint_tick = /** @type {((inputs?: Movement_Breakdown_Hint_TickInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Hint_TickInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_hint_tick(inputs)
});